import { render, staticRenderFns } from "./whiteSlipPaymentTwo.vue?vue&type=template&id=47fd70b4&scoped=true"
import script from "./whiteSlipPaymentTwo.vue?vue&type=script&lang=js"
export * from "./whiteSlipPaymentTwo.vue?vue&type=script&lang=js"
import style0 from "./whiteSlipPaymentTwo.vue?vue&type=style&index=0&id=47fd70b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd70b4",
  null
  
)

export default component.exports